/* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@next/next/no-img-element */
import React from 'react';
import goals from './assets/goals.svg';
import goalsMobile from './assets/goals-mobile.svg';
import bottle from './assets/bottle.svg';
import { useWindowSize } from '~/hooks/useWindowSize';
import styles from './WineGoals.module.scss';
import { LinkWithLayers } from '~/vinovest-design-system/components/LinkWithLayers';

export const WineGoals = () => {
    const { isDesktop } = useWindowSize();

    return (
        <div className={styles.wrapper}>
            <h2 className={'heading-2'}>Your Wine, Your Goals, Your Way</h2>
            <div className={styles.contentWrapper}>
                <div className={styles.imageWrap}>
                    <img
                        className={styles.goalsImg}
                        src={!isDesktop ? goalsMobile.src : goals.src}
                        alt={'bottles of wine'}
                    />
                    {isDesktop && <img className={styles.bottle} src={bottle.src} alt={'bottle'} />}
                </div>
                <div className={styles.textWrap}>
                    <p>
                        The Vinovest Marketplace gives you complete control over your wine portfolio. You select the
                        wine. You choose when to sell. You earn the profits.
                    </p>
                    <p>
                        The first of its kind, the Vinovest Marketplace offers a refreshingly hands-on approach to wine
                        investing. Buy and sell investment-grade wines from Burgundy, Bordeaux, and beyond without hold
                        times, a minimum balance, or a portfolio manager - just like the stock market.
                    </p>
                    <p>Welcome to the future of wine investing.</p>
                </div>
            </div>
            <div className={styles.buttonWrap}>
                <LinkWithLayers theme={'black'} className={styles.button} href={'/trade/marketplace'}>
                    Fund Now
                </LinkWithLayers>
            </div>
        </div>
    );
};
